export const SET_COMMERCIAL_AGENTS = 'SET_COMMERCIAL_AGENTS';
export const SET_IS_LOADING_GET_COMMERCIAL_AGENTS = 'SET_IS_LOADING_GET_COMMERCIAL_AGENTS';
export const SET_IS_LOADING_CREATE_UPDATE_COMMERCIAL_AGENT = 'SET_IS_LOADING_CREATE_UPDATE_COMMERCIAL_AGENT';
export const SET_UPDATED_COMMERCIAL_AGENT = 'SET_UPDATED_COMMERCIAL_AGENT';
export const SET_AGENT_SELECTED = 'SET_AGENT_SELECTED';
export const DELETE_COMMERCIAL_AGENT = 'DELETE_COMMERCIAL_AGENT';
export const SET_IS_LOADING_DELETE_COMMERCIAL_AGENT = 'SET_IS_LOADING_DELETE_COMMERCIAL_AGENT';
export const SET_IS_LOADING_ASSIGN_AGENTS_TO_CLIENT = 'SET_IS_LOADING_ASSIGN_AGENTS_TO_CLIENT';
